import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

const SETTINGS_DOC_REF = doc(db, 'settings', 'globals');

const DEFAULT_SETTINGS = {
  systemBranches: [
    { id: 'gebze', name: 'Gebze Şubesi', color: 'from-forest-600 to-forest-800' },
    { id: 'kurtkoy', name: 'Kurtköy Şubesi', color: 'from-blue-600 to-blue-800' }
  ],
  isSystemMaintenance: false,
  isCatalogClosed: false
};

// Sistem ayarlarını getir
export const getSystemSettings = async () => {
  try {
    const docSnap = await getDoc(SETTINGS_DOC_REF);
    if (docSnap.exists()) {
      return docSnap.data();
    } else {
      // Döküman yoksa başlangıç ayarlarıyla oluştur
      await setDoc(SETTINGS_DOC_REF, DEFAULT_SETTINGS);
      return DEFAULT_SETTINGS;
    }
  } catch (error) {
    console.error("Ayar çekme hatası:", error);
    throw error;
  }
};

// Belirli ayarları güncelle (kısmi)
export const updateSystemSettings = async (updates) => {
  try {
    await updateDoc(SETTINGS_DOC_REF, updates);
  } catch (error) {
    console.error("Ayar güncelleme hatası:", error);
    throw error;
  }
};

// Tam ayarları üzerine yaz
export const setSystemSettings = async (settings) => {
  try {
    await setDoc(SETTINGS_DOC_REF, settings);
  } catch (error) {
    console.error("Ayar kaydetme hatası:", error);
    throw error;
  }
};
